import React, { useEffect } from "react";
import CourseProgressCard from "components/widget/CourseProgressCard";
import { connect } from "react-redux";
import { 
	getTrainingClassList, 
	doTrainingClassDelete,
	doTrainingClassReset,
} from "../../../../redux/trainingclass/trainingClassState";
import dayjs from "dayjs";
import { Card } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideGraduationCap } from "lucide-react";




const TrainingCoursesTable = ({
	recordList, 
	pagination, 
	doSearch, 
	user,
}) => {

useEffect(() => {
doSearch({ paginate: pagination?.per_page, user_id: user.id });
}, [doSearch, pagination?.per_page, user.id]);

const formatSchedule = (from, to) => {
		if (!from || !to) return "No schedule available";
		return `${dayjs(from).format("MMM DD, YYYY")} → ${dayjs(to).format("MMM DD, YYYY")}`;
	};

return (
		<HeaderComponent
			title="My Courses"
			description="Your enrolled courses and training programs"
			bgcolor="bg-white"
			labelIcon={<LucideGraduationCap size={20}/>}
			

		>
				{recordList && recordList.length > 0 ? (
					recordList.map((item) => (
					<CourseProgressCard
						key={item.tcl_id}
						title={item.tcl_title}
						date={formatSchedule(item.tcl_schedule_date_from, item.tcl_schedule_date_to)}
						percent={0}
						showProgress={false}
					/>
				))
					) : (
						<p className="text-gray-500 text-center col-span-full">
							No available classes found.
						</p>
					)}   
		</HeaderComponent>
		
  );
};

const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassList?.items,
	pagination: state.trainingClass.trainingClassList?.pagination,
	filters: state.trainingClass.trainingClassList?.filters,
	requesting: state.trainingClass.trainingClassList?.requesting,
	error: state.trainingClass.trainingClassList?.error,
	user: state.auth.user,
	user: state.auth.user,


});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCoursesTable);
